// @core/api/endpoints/landing/get_landing_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LandingTemplateResponse,
} from '../../../types/landing';

const BASE_PATH = '/landing';

/**
 * Get landing template
 * Retrieves a landing page template by ID.
 */
export async function GetLandingTemplate(
  template_id: string,
  options?: RequestOptions
): Promise<LandingTemplateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/landing/templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.get<LandingTemplateResponse>(requestPath, { ...requestOptions });
}
